// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"61399bc0","370":"5e66d25c","382":"d193c63c","658":"082619cf","787":"73924d72","791":"0a7d1185"}[chunkId] + ".chunk.js";
};